import { ButtonSecondary } from '@fukku/button/Secondary'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import styles from './InactivePurchasesButton.module.scss'

interface InactivePurchasesButtonProps {
	readonly handleClick?: () => void
	readonly isLoading?: boolean
}
export function InactivePurchasesButton({
	handleClick,
	isLoading,
}: InactivePurchasesButtonProps) {
	const { t } = useLabels()
	return (
		<ButtonSecondary
			className={styles.button}
			onClick={handleClick}
			data-testid='myPurchases.showHistory.button'
			isLoading={isLoading}
		>
			{t('myPurchases.showHistory.button')}
		</ButtonSecondary>
	)
}
